import React, { useEffect, useState } from "react";

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BsHeart } from "react-icons/bs";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

import {
	FaFacebookMessenger,
	FaFacebookSquare,
	FaTwitter,
	FaPinterest,
} from "react-icons/fa";
import {
	BodyContainer,
	PageLinking,
	ProductName,
	Price,
	Heading,
	ProductFavorite,
	Button,
	ButtonPrimary,
	Span,
	ThumblineContainer,
	ImageThumbs,
	MainImageContainer,
} from "../../styles/Body";

// variations viewer
import VariationViewer from "../VariationViewer";

// loading
import ProducViewLoadingSkeleton from "./ProducView__loadingSkeleton";

// app messages
import {
	COMBINATION_NOT_AVAILABLE,
	COMBINATION_OUT_OF_STOCK
} from "utlis/AppMessages/AppMessages";
import ProductSlider from "./ProductSlider";

function Body(props) {
	// props
	const {
		availableCombinations,

		allowedVariantsValues,
		setAllowedVariantsValues,

		currentRoute,
		productsDetailsLoading,
		productDetails,
		productDetailsCombinationWise,
		combinationNotAvailable,

		variantMainFields,
		productCombinationsImages,

		selectedOptionsByUser,
		setSelectedOptionsByUser,

		buttonLoading,
		handleAddToCartButtonClick,

		generateValues,

		selectedValue,
		setSelectedValue,

		productQuantity,
		setProductQuantity
	} = props

	// states
	const [defaultImg, setDefaultImg] = useState(null)

	// setting default image
	// useEffect(() => {
	// 	if (productDetailsCombinationWise && Object.keys(productDetailsCombinationWise)?.length) {
	// 		if (productCombinationsImages[productDetailsCombinationWise?.sku]?.medium && productCombinationsImages[productDetailsCombinationWise?.sku]?.medium[0]) {
	// 			setDefaultImg(productCombinationsImages[productDetailsCombinationWise.sku]?.medium[0])
	// 		} else {
	// 			if (productDetails?.images?.main_thumb?.medium) {
	// 				setDefaultImg(productDetails.images.main_thumb.medium)
	// 			} else {
	// 				setDefaultImg(noImgFoundImg)
	// 			}
	// 		}
	// 	} else {
	// 		if (productDetails?.images?.main_thumb?.medium) {
	// 			setDefaultImg(productDetails.images.main_thumb.medium)
	// 		} else {
	// 			setDefaultImg(noImgFoundImg)
	// 		}
	// 	}

	// }, [productDetailsCombinationWise, productDetails, productCombinationsImages])

	// const handleImageChange = (ev, img) => {
	// 	ev.preventDefault()

	// 	if (img) {
	// 		setDefaultImg(img)
	// 	}
	// }

	// PRODUCT IMAGES
	const [productAllImages, setProductAllImages] = useState([])
	const [productCombinationAllImages, setProductCombinationAllImages] = useState([])

	// extracting images
	useEffect(() => {
		// combinations images
		if (productDetailsCombinationWise && productDetailsCombinationWise?.sku) { // product combination wise is available and sku is available too
			const allImagesArrayMedium = productCombinationsImages[productDetailsCombinationWise.sku]?.medium

			if (allImagesArrayMedium) { // if images available
				setProductCombinationAllImages(allImagesArrayMedium) // setting all images array
			} else { // if no images found
				setProductCombinationAllImages([]) // setting all images array
			}
		}

		// main images
		if (productDetails?.images) { // if product images available
			const mainImageMedium = productDetails?.images?.main_thumb?.medium
			const otherImageArrayMedium = productDetails?.images?.other?.medium

			if (mainImageMedium && otherImageArrayMedium) {
				const allImagesArrayMedium = [mainImageMedium, ...otherImageArrayMedium]

				setProductAllImages(allImagesArrayMedium) // setting all images array
			} else {
				if (mainImageMedium) {
					const allImagesArrayMedium = [mainImageMedium]

					setProductAllImages(allImagesArrayMedium) // setting all images array
				}
			}
		} else { // if no images found
			setProductAllImages([]) // setting all images array
		}
	}, [
		productDetailsCombinationWise,
		productCombinationsImages,
		productDetails
	])

	useEffect(() => {
		setProductAllImages([
			...productCombinationAllImages,	
			...productAllImages,
		]) // setting all images array
	}, [productCombinationAllImages])

	// on values chagne
	const handleQuantityChange = ev => {
		const inpVal = ev.target.value
		setProductQuantity(inpVal) //setting input value

		// if (inpVal && parseInt(inpVal) !== 0) {
		// }
	}

	// on blur of quantity field
	const handleQuantityBlur = ev => {
		const inpVal = ev.target.value

		if (inpVal === "" || inpVal === "0") {
			setProductQuantity("1") //setting input value
		}
	}

	// increase value
	const handleValueIncrease = ev => {
		ev.preventDefault()
		let val = parseInt(productQuantity) + 1
		setProductQuantity(val) //setting input value
	}

	// increase value
	const handleValueDecrease = ev => {
		ev.preventDefault()

		if (productQuantity > 1) {
			const val = parseInt(productQuantity) - 1
			setProductQuantity(val) //setting input value
		}
	}

	return (
		<BodyContainer className="d-flex flex-wrap">
			<div className="product-details__slider media-body">
				<ProductSlider
					loading={productsDetailsLoading}
					productImages={productAllImages}
					productsDetailsLoading={productsDetailsLoading}
				/>
			</div>

			{/* details */}
			<div className="product-details__details">
				{
					productsDetailsLoading ? (
						<React.Fragment>
							<ProducViewLoadingSkeleton />
						</React.Fragment>
					) : (
						<React.Fragment>
							<PageLinking>
								<span>Store</span>&ensp;/&ensp;
								<span className="text-uppercase">{currentRoute?.routeName?.split("-")?.join(' ')}</span>
							</PageLinking>

							<ProductName>{productDetailsCombinationWise?.product_name ?? productDetails?.product_name}</ProductName>

							<div className="mb-0">
								<Price>
									{/* price only */}
									<span>{productDetailsCombinationWise?.display_price ?? productDetails.display_price}</span>

									{/* {
										// price with promo price
										productDetails?.promo_price ? (
											<React.Fragment>
												<span className="promo-price">${productDetails.promo_price}</span>
												<span className="ms-2">{productDetails.price}</span>
											</React.Fragment>
										) : null
									} */}
								</Price>

								<div className={`product-page-variation-viewer ${(productDetails.is_purchasability === 2) ? "element-disabled" : ""}`}>
									<div className="inner">
										<VariationViewer
											variantMainFields={variantMainFields}

											availableCombinations={availableCombinations}

											allowedVariantsValues={allowedVariantsValues}
											setAllowedVariantsValues={setAllowedVariantsValues}

											selectedOptionsByUser={selectedOptionsByUser}
											setSelectedOptionsByUser={setSelectedOptionsByUser}

											generateValues={generateValues}

											selectedValue={selectedValue}
											setSelectedValue={setSelectedValue}

											setProductQuantity={setProductQuantity}
										/>
									</div>
								</div>
							</div>

							{ // if any variation is out of stock
								(productDetailsCombinationWise?.stock === 0) ? (
									<p>NOTE: {COMBINATION_OUT_OF_STOCK}</p>
								) : null
							}

							{ // if any variation is inactive
								(combinationNotAvailable) ? (
									<p>NOTE: {COMBINATION_NOT_AVAILABLE}</p>
								) : null
							}
							{/* if call for ptice is available */}
							{
								(productDetails.is_purchasability === 2) ? (
									<div className="call-for-price-message mb-3">
										<p className="mb-0">NOTE: {productDetails.call_for_price_label ?? "This Product cannot be purchased online"}</p>
									</div>
								) : null
							}
							{
								(productDetails.is_purchasability === 3) ? (
									<div className="call-for-price-message mb-3">
										<p className="mb-0">
											<span className="d-block mb-1">{productDetails.preorder_message}</span>
											<span className='d-block'>
												<span className="st-fw-600">Available on:</span> {productDetails.preorder_date}
											</span>
										</p>
									</div>
								) : null
							}

							{
								((productDetailsCombinationWise?.stock === 0) || (productDetails.stock === 0) || combinationNotAvailable) ? (
									<div className="add-to-bag-btn">
										<button className="text-capitalize btn btn-dark disabled w-100" style={{ pointerEvents: "none" }}>
											out of stock
										</button>
									</div>
								) : (
									<div className={`add-to-bag-btn d-flex ${((productDetails.is_purchasability === 2) || combinationNotAvailable || buttonLoading || (variantMainFields?.length && !allowedVariantsValues?.length)) ? "element-disabled" : ""}`}>
										<div className="quantity-selector d-inline-flex">
											<input
												type="number"
												value={productQuantity}
												onChange={handleQuantityChange}
												onBlur={handleQuantityBlur}
											/>
											<div className="btns">
												<span className="plus d-flex align-items-center justify-content-center" onClick={handleValueIncrease}>
													<AiOutlinePlus />
												</span>
												<span className="minus d-flex align-items-center justify-content-center" onClick={handleValueDecrease}>
													<AiOutlineMinus />
												</span>
											</div>
										</div>
										<button
											className={`text-capitalize btn btn-dark media-body ms-2`}
											// disabled={combinationNotAvailable || buttonLoading || (!allowedVariantsValues?.length)}
											onClick={(ev) => handleAddToCartButtonClick(ev, productDetails)}>
											{buttonLoading ? (
												<Spinner
													animation="border"
													size="sm"
													className="position-relative"
													style={{
														top: 1,
													}}
												/>
											) : (
												<React.Fragment>
													{
														(productDetails.is_purchasability === 3) ? (
															<span>pre order</span>
														) : (
															<span>add to bag</span>
														)
													}
												</React.Fragment>
											)}
										</button>
									</div>
								)
							}

							<div className="mb-4">
								<Heading>Product Details </Heading>
								{
									productDetailsCombinationWise?.description ? ( // if the desctiption exists in the combinations selected by the user
										<div>
											<p className="mb-3">
												{productDetailsCombinationWise.description}
											</p>
										</div>
									) : (
										<React.Fragment>
											{
												productDetails?.description ? (
													<div>
														<p className="mb-3">
															{productDetails.description}
														</p>
													</div>
												) : null
											}
										</React.Fragment>
									)
								}

								<div className="mb-1">
									<span>Dimensions: </span> <span>
										{`${productDetailsCombinationWise?.height ?? productDetails.height} x ${productDetailsCombinationWise?.width ?? productDetails.width} x ${productDetailsCombinationWise?.length ?? productDetails.length}`}
									</span>
								</div>

								{
									productDetailsCombinationWise?.upc ? (
										<div className="mb-1">
											<span>UPC: </span> <span>{productDetailsCombinationWise.upc}</span>
										</div>
									) : (
										<React.Fragment>
											{
												productDetails?.upc_code ? (
													<div className="mb-1">
														<span>UPC: </span> <span>{productDetails.upc_code}</span>
													</div>
												) : null
											}
										</React.Fragment>
									)
								}

								{/* {
									productDetailsCombinationWise?.sku ? (
										<div className="mb-1">
											<span>SKU: </span> <span>{productDetailsCombinationWise.sku}</span>
										</div>
									) : (
										<React.Fragment>
											{
												productDetails?.sku ? (
													<div className="mb-1">
														<span>SKU: </span> <span>{productDetails.sku}</span>
													</div>
												) : null
											}
										</React.Fragment>
									)
								} */}
							</div>

							{/* <div className="mb-4">
								<ProductFavorite>Save this product for later</ProductFavorite>
								<Button>
									<BsHeart style={{ marginRight: "10px" }} /> Favorite
								</Button>
							</div>

							<div className="mb-4">
								<ProductFavorite>Have questions?</ProductFavorite>
								<ButtonPrimary>
									<FaFacebookMessenger
										style={{ marginRight: "10px", color: "#fff" }}
									/>
									Message Us
								</ButtonPrimary>
							</div>

							<div className="mb-4">
								<ProductFavorite>
									Share this product with your friends
								</ProductFavorite>
								<div>
									<Span>
										<FaFacebookSquare
											style={{ color: "#425497", fontSize: "18px" }}
										/>{" "}
										Share
									</Span>
									<Span>
										<FaTwitter style={{ color: "#00b7ec", fontSize: "18px" }} /> Tweet
									</Span>
									<Span>
										<FaPinterest style={{ color: "#cc002b", fontSize: "18px" }} />{" "}
										Pine It
									</Span>
								</div>
							</div> */}
						</React.Fragment>
					)
				}
			</div>
		</BodyContainer>
	);
}

export default connect(
	null,
	null
)(Body);
